import {
  ActivityType,
  EmploymentType,
  ExperienceType,
  ExtraServiceStatus,
  FlagStatus,
  LmsCourseAccess,
  MeetingStatus,
  SessionStatus,
  EnrollmentStatusTypes,
  EnrollmentStageStatus,
} from '../enums';

export const UPLOAD_INVOICE_STATES = {
  NOT_GENERATED: 'NOT_GENERATED',
  NOTHING_TO_UPLOAD: 'NOTHING_TO_UPLOAD',
  AWAITING_UPLOAD: 'AWAITING_UPLOAD',
  UPLOADED: 'UPLOADED',
  INVOICE_ACCEPTED: 'INVOICE_ACCEPTED',
  REJECTED: 'REJECTED',
  INVALID_E_INVOICE: 'INVALID_E_INVOICE',
  ERROR: 'ERROR',
};

export const FLAG_STATUS: { [key: string]: any } = {
  [FlagStatus.ACTIVE]: 'Active',
  [FlagStatus.CLOSED]: 'Closed',
};

export const GET_SESSION_COMPLETED_STATUSES = (includePendingReviewCheck = false) => [
  SessionStatus.NEEDS_FEEDBACK,
  SessionStatus.COMPLETED,
  SessionStatus.PAID,
  SessionStatus.UNPAYABLE,
  ...(includePendingReviewCheck ? [SessionStatus.PENDING_REVIEW] : []),
];

export const LMS_COURSE_ACCESS: { [key: string]: any } = {
  [LmsCourseAccess.FREE]: 'Free',
  [LmsCourseAccess.DRAFT]: 'Draft',
};

export const EXTRA_SERVICE_STATUS: { [key: string]: any } = {
  [ExtraServiceStatus.CREATED]: 'Created',
  [ExtraServiceStatus.PAID]: 'Paid',
};

export const MEETING_STATUSES: { [key: string]: any } = {
  [MeetingStatus.SCHEDULED]: 'Scheduled',
  [MeetingStatus.RESCHEDULED]: 'Rescheduled',
  [MeetingStatus.CANCELLED]: 'Cancelled',
  [MeetingStatus.MISSED]: 'Missed',
  [MeetingStatus.STARTED]: 'Started',
  [MeetingStatus.ENDED]: 'Ended',
  [MeetingStatus.NO_SHOW]: 'No Show',
};

export const MEETING_STATUSES_OPTIONS = Object.values(MeetingStatus)
  .filter((value) => typeof value === 'number')
  .map((value) => ({
    label: MEETING_STATUSES[value as MeetingStatus],
    value: value as MeetingStatus,
  }));

export const IRRELEVANT_MEETING_STATUSES = [
  MeetingStatus.CANCELLED,
  MeetingStatus.RESCHEDULED,
  MeetingStatus.MISSED,
  MeetingStatus.NO_SHOW,
];

export const ENROLLMENT_STATUS_TYPES: { [key: number]: string } = {
  [EnrollmentStatusTypes.Active]: 'Active',
  [EnrollmentStatusTypes.Suspended]: 'Suspended',
  [EnrollmentStatusTypes.Canceled]: 'Canceled',
  [EnrollmentStatusTypes.Completed]: 'Completed',
  [EnrollmentStatusTypes.UnderObservation]: 'Under Observation',
  [EnrollmentStatusTypes.WaitingForPayment]: 'Waiting for payment',
};

export const ENROLLMENT_STATUS_OPTIONS = Object.keys(EnrollmentStatusTypes)
  .filter((key) => !isNaN(Number(EnrollmentStatusTypes[key as keyof typeof EnrollmentStatusTypes])))
  .map((key) => ({
    label:
      ENROLLMENT_STATUS_TYPES[EnrollmentStatusTypes[key as keyof typeof EnrollmentStatusTypes]],
    value: EnrollmentStatusTypes[key as keyof typeof EnrollmentStatusTypes],
  }));

export const ENROLLMENT_STAGE_STATUS_TYPES: { [key: number]: string } = {
  [EnrollmentStageStatus.NotStarted]: 'Not Started',
  [EnrollmentStageStatus.NoMeetingScheduled]: 'No Meeting Scheduled',
  [EnrollmentStageStatus.MentorAllocated]: 'Mentor Allocated',
  [EnrollmentStageStatus.NeedsReallocation]: 'Needs Reallocation',
  [EnrollmentStageStatus.Ongoing]: 'Ongoing',
};

export const SESSION_STATUSES: { [key: number]: string } = {
  [SessionStatus.PENDING]: 'Pending',
  [SessionStatus.SCHEDULED]: 'Scheduled',
  [SessionStatus.ONGOING]: 'Ongoing',
  [SessionStatus.NEEDS_FEEDBACK]: 'Needs feedback',
  [SessionStatus.COMPLETED]: 'Completed',
  [SessionStatus.PENDING_REVIEW]: 'Pending review',
  [SessionStatus.PAID]: 'Paid',
  [SessionStatus.UNPAYABLE]: 'Unpayable',
};

export const SESSION_STATUSES_OPTIONS = Object.keys(SessionStatus)
  .filter((key) => !isNaN(Number(SessionStatus[key as keyof typeof SessionStatus])))
  .map((key) => ({
    label: SESSION_STATUSES[SessionStatus[key as keyof typeof SessionStatus]],
    value: SessionStatus[key as keyof typeof SessionStatus],
  }));

export const STAGE_STATUS_OFFSET = 1000;

export const ENROLLMENT_STAGE_STATUS_OPTIONS = [
  {
    label: ENROLLMENT_STATUS_TYPES[EnrollmentStatusTypes.Active],
    value: EnrollmentStatusTypes.Active,
  },
  ...Object.keys(EnrollmentStageStatus)
    .filter(
      (key) => !isNaN(Number(EnrollmentStageStatus[key as keyof typeof EnrollmentStageStatus]))
    )
    .map((key) => ({
      label:
        ENROLLMENT_STAGE_STATUS_TYPES[
          EnrollmentStageStatus[key as keyof typeof EnrollmentStageStatus]
        ],
      value: STAGE_STATUS_OFFSET + EnrollmentStageStatus[key as keyof typeof EnrollmentStageStatus],
      indent: true,
    })),
  {
    label: ENROLLMENT_STATUS_TYPES[EnrollmentStatusTypes.UnderObservation],
    value: EnrollmentStatusTypes.UnderObservation,
  },
  {
    label: ENROLLMENT_STATUS_TYPES[EnrollmentStatusTypes.Suspended],
    value: EnrollmentStatusTypes.Suspended,
  },
  {
    label: ENROLLMENT_STATUS_TYPES[EnrollmentStatusTypes.Canceled],
    value: EnrollmentStatusTypes.Canceled,
  },
  {
    label: ENROLLMENT_STATUS_TYPES[EnrollmentStatusTypes.Completed],
    value: EnrollmentStatusTypes.Completed,
  },
  {
    label: ENROLLMENT_STATUS_TYPES[EnrollmentStatusTypes.WaitingForPayment],
    value: EnrollmentStatusTypes.WaitingForPayment,
  },
];

export const STUDENT_STATUS = [
  // 'Waiting for payment',
  // 'Active',
  'In-between courses',
  'Taking courses',
  'All courses completed',
  'Not started any course',
  // 'Alumni',
];
